import {Injectable} from '@angular/core';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FeaturePermissionsService {
  permissionList;

  constructor(private authService: AuthService) {
    this.authService.getFeaturePermissionList.subscribe(permission => this.permissionList = permission);
  }

  resolveFeaturePermissions(requiredPermissions: any[]): { [key: string]: boolean } {
    return requiredPermissions.reduce((acc, permission) => {
      acc[permission.key] = this.authService.hasFeaturePermission(permission);
      return acc;
    }, {});
  }
  
}
